import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Codetable type.
 *
 * @namespace CodetableService
 */

var CodetableService = /*#__PURE__*/function () {
  /**
   * Creates an instance of CodetableService.
   *
   * @private
   * @param {any} json
   * @memberof CodetableService
   */
  function CodetableService(json) {
    _classCallCheck(this, CodetableService);

    this.tableName = json.tableName;
    this.value = json.value;
    this.description = json.description;
  }
  /**
   * Creates a codetable from JSON.
   *
   * @static
   * @param {any} obj input
   * @returns Codetable
   * @memberof CodetableService
   */


  _createClass(CodetableService, null, [{
    key: "fromJSON",
    value: function fromJSON(obj) {
      if (obj) {
        return new CodetableService(obj);
      }

      return null;
    }
  }]);

  return CodetableService;
}();

export { CodetableService as default };